import { render, staticRenderFns } from "./HealthcareExpensesConfirmNew.vue?vue&type=template&id=3f0aaa44&scoped=true"
import script from "./HealthcareExpensesConfirmNew.vue?vue&type=script&lang=ts"
export * from "./HealthcareExpensesConfirmNew.vue?vue&type=script&lang=ts"
import style0 from "./HealthcareExpensesConfirmNew.vue?vue&type=style&index=0&id=3f0aaa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0aaa44",
  null
  
)

export default component.exports